/* eslint-disable max-lines-per-function */
import { ReactElement } from 'react';

import { VisitSettlement } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import { VisitSettlementStatusDescription, VisitSettlementStatusIcon } from '~libs.shared.visit-settlement';

import { AppointmentDetailsInfoItem } from '../AppointmentDetailsInfoItem';

import {
   StyledAmountWrapper,
   StyledPaidAmountText,
   StyledRequiredAmountText,
} from './AppointmentVisitSettlementInfoItem.styled';

type AppointmentVisitSettlementInfoItemProps = {
   readonly appointmentId: number;
   readonly visitSettlement: VisitSettlement | null;
};

export const AppointmentVisitSettlementInfoItem = (props: AppointmentVisitSettlementInfoItemProps): ReactElement => {
   return (
      <AppointmentDetailsInfoItem
         testId={'appointmentVisitSettlement'}
         icon={<VisitSettlementStatusIcon appointmentId={props.appointmentId} />}
         content={<VisitSettlementStatusDescription appointmentId={props.appointmentId} />}
         rightContent={
            props.visitSettlement ? (
               <StyledAmountWrapper>
                  <TextSeparator separator={TextSeparatorType.SPACE_SLASH_SPACE}>
                     <StyledPaidAmountText
                        testId={'paidAmount'}
                        value={props.visitSettlement.totalPaidAmount.asNumber()}
                        stripDecimalZeroes
                        hideCurrency
                     />
                     <StyledRequiredAmountText
                        testId={'requiredAmount'}
                        value={props.visitSettlement.totalDueAmount.asNumber()}
                        stripDecimalZeroes
                     />
                  </TextSeparator>
               </StyledAmountWrapper>
            ) : (
               <></>
            )
         }
      />
   );
};
